import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      title: {
        paddingBlock: tokens.spacingGap100,
        marginInlineStart: tokens.spacingGap100,
      },

      separator: {
        marginBlock: tokens.spacingGap100,
        marginInline: tokens.spacingGap100,
      },
    },
  } as const
}
